import React, { Component } from "react";
import { Cancel } from "@material-ui/icons";
import { SecondaryButton } from "@loanbossinc/component-library";
import { StyledSecondaryButtonWrapper, StyledToggleSelect, DeleteWrapper, OuterWrapper, FileWrapper } from './StandAloneAttachmentsItemStyles';

const buttonOptions = [
  { name: "Public", index: 0 },
  { name: "Internal", index: 1 },
];

export class StandAloneAttachmentsItem extends Component {

  setIsPrivate(isPrivate) {
    const newFile = { ...this.props.file, isPrivate }
    this.props.onUpdate(newFile);
  }
  getPrivateToggle() {
    if (!this.props.authentication.isGuest) {
      const index = this.props.file.isPrivate ? 1 : 0;
      return (
        <StyledToggleSelect
          isPrivate={this.props.file.isPrivate}
          options={buttonOptions}
          onChange={() => this.setIsPrivate(!this.props.file.isPrivate)}
          defaultIndex={index}
        />);
    }
  }

  getDeleteButton = () => {
    const { file } = this.props;
    return (!this.props.authentication.isGuest || this.props.file.userId === this.props.authentication.user.id)
      && <Cancel onClick={() => this.onRemove(file)} />
  }

  onRemove = () => this.props.onRemove(this.props.file);

  render() {
    const { onRemove, onDownload, onUpdate, ...other } = this.props;

    return (
      <OuterWrapper isPrivate={this.props.file.isPrivate}>
        <div className="item-content">
          <FileWrapper name={`attachmentNamed${this.props.file.name}`}>{this.props.file.name}</FileWrapper>
          <DeleteWrapper>{this.getDeleteButton()}</DeleteWrapper>
        </div>

        <div className="item-actions">
          {this.getPrivateToggle()}
          <StyledSecondaryButtonWrapper>
            <SecondaryButton name={`downloadAttachment${this.props.file.name}`} label="Download" onClick={onDownload} size="sm" />
          </StyledSecondaryButtonWrapper>
        </div>
      </OuterWrapper>
    );
  }
}
